import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b0588f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import { ref, watch } from 'vue'
import {
  ElInput
} from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Array as () => string[],
    default: () => []
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props





const leftNum = ref('')
const rightNum = ref('')

watch(() => props.modelValue, () => {
  setDefaultValue()
}, { deep: true })

function setDefaultValue () {
  if (props.modelValue && props.modelValue.length) {
    leftNum.value = props.modelValue[0]
    if (props.modelValue.length > 1) {
      rightNum.value = props.modelValue[1]
    }
  }
}
setDefaultValue()

function onInput () {
  const data = [leftNum.value, rightNum.value]
  emits('update:modelValue', data)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElInput), {
      modelValue: leftNum.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((leftNum).value = $event)),
      onInput: onInput
    }, null, 8, ["modelValue"]),
    _hoisted_2,
    _createVNode(_unref(ElInput), {
      modelValue: rightNum.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rightNum).value = $event)),
      onInput: onInput
    }, null, 8, ["modelValue"])
  ]))
}
}

})